import React from "react";
import { Link } from "react-router-dom";
import Nav from "./Nav";

const Header = () => {
  return (
    <header className="site-header">
      <div className="portfolio-container header-inner">
        <Link className="brand-link" to="/" aria-label="Paul Carter home">
          <span className="brand-name">Paul Carter</span>
          <span className="brand-role">Software Developer</span>
        </Link>
        <Nav />
      </div>
    </header>
  );
};

export default Header;
